var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconValidate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.90501,0.1875 C27.79367,0.1875 35.81001,8.20384 35.81001,18.09251 C35.81001,27.981169 27.79367,35.9975128 17.90501,35.9975128 C8.016344,35.9975128 0,27.981169 0,18.09251 C0,8.20384 8.016344,0.1875 17.90501,0.1875 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "20.29115 0.9305 22.78106 3.50435 9.01659 16.779231 0.162003 8.44221 2.623941 5.84039 8.98861 11.82738"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDD1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_b_Module_Remboursement_Remboursement_OK-Copy-2",
    transform: "translate(-393.000000, -101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(393.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.812500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#4FC380",
    mask: "url(#mask-2)",
    points: "-17.90501 53.90252 53.71502 53.90252 53.71502 -17.71751 -17.90501 -17.71751"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(7.000000, 10.812500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-17.743 34.684238 40.68609 34.684238 40.68609 -16.974502 -17.743 -16.974502"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: -10.3125,
    x2: 91.5,
    y2: -10.3125,
    id: "Line",
    stroke: "#979797",
    strokeLinecap: "square",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.5,
    y1: -10.3125,
    x2: -9.5,
    y2: -10.3125,
    id: "Line-2",
    stroke: "#979797",
    strokeLinecap: "square",
    mask: "url(#mask-4)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValidate);
export default __webpack_public_path__ + "static/media/icon-validate.a42f8ca4.svg";
export { ForwardRef as ReactComponent };